module.exports = __webpack_public_path__ + "static/media/icon_guardian_app.6cbebc2f.png";